module.exports = __webpack_public_path__ + "img/Airbnb-Work-From-Home-Couches-Landing-page-Footer-and-Page.8f839339.jpg";